import React from "react";
import {Route, Redirect} from "react-router-dom";


export const ProtectedRoute = ({isLoggedIn: isLoggedIn, component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (isLoggedIn === "LOGGED_IN") {
                    return <Component {...props} />;
                } else {
                    return (
                        <Redirect
                            to={{
                                pathname: "/",
                                state: {
                                    from: props.location
                                }
                            }}
                        />
                    );
                }

            }}
        />
    );
};